import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';
import * as commonActions from '@common/common.action';
import { useDispatch, useSelector } from 'react-redux';
import EditorContainer from '@componentes/editor/editor.container';
import { useHistory } from 'react-router-dom';
import * as editorActions from '@componentes/editor/editor.action';
import { errors } from '../../pages/error/erros';
import * as editorUtil from '../../componentes/editor/editor.util';
import { etapasEnum } from '@util/defaultValues';
import { editorUrl } from '@constants/defaultValues';
import IntlMessage from '../../../src/helpers/intlMessage';

export default function ModalConclusao(props) {
	const history = useHistory();
	const dispatch = useDispatch();
	const laudo = useSelector((state) => state.commonReducer.detalhes.laudo);
	const inicializado = useSelector(
		(state) => state.editorComponent.editorCarregado
	);
	const [showModalConclusao, setShowModalConclusao] = useState(false);
	const [verificarTexto, setVerificarTexto] = useState(false);

	useEffect(() => {
		window.addEventListener('message', ({ data }) => {
			if (data.value && verificarTexto) {
				setVerificarTexto(false);
				if (data.args && data.args.action === 'getPlainTextContainer') {
					dispatch(commonActions.showFadeCarregando(true));
					if (!data.value.plain || data.value.plain.trim() === '') {
						dispatch(
							commonActions.showAlerta(
								'erro',
								'Favor digitar um texto no laudo',
								2000
							)
						);
						dispatch(commonActions.showFadeCarregando(false));
					} else {
						dispatch(commonActions.showFadeCarregando(false));
						setShowModalConclusao(!showModalConclusao);
						props.onModal(!showModalConclusao);
						props.confirmar({rtf: data.value.rtf, plain: data.value.plain});
					}
				}
			}
		});
		return window.removeEventListener('message', null, true);
	}, [verificarTexto]);

	const verificaEditor = () => {
		const frame = document.getElementById('iframe-editor-component');
		if (frame !== null) {
			frame.contentWindow.postMessage(
				{
					method: 'recuperarTextoRtfAndPlainText',
					urlHost: editorUrl,
					args: {
						action: 'getPlainTextContainer',
					},
				},
				editorUrl
			);
		}
		setVerificarTexto(!verificarTexto);
	};

	function carregarEditor() {
		const blank = false;
		try {
			editorUtil.Inicializar(laudo, etapasEnum.CONCLUSAO.toLowerCase(), dispatch, blank);
		} catch (error) {
			const { message } = error;
			let title = '';
			const origin = 'Modal Conclusão';
			const code = 101;

			errors.map((err) => {
				if (err.code === code) {
					title = err.title;
				}
				return err;
			});
			window.location.replace(
				`/error/${btoa(title)}/${btoa(message)}/${btoa(code)}/${btoa(origin)}/`
			);
		}
	}

	useEffect(() => {
		setShowModalConclusao(props.showModal);
		dispatch(editorActions.showEditor(true));
		dispatch(editorActions.editorAltura('325px'));
		if (props.showModal) {
			dispatch(commonActions.showFadeCarregando(true));
			carregarEditor();
			if (inicializado) {
				setShowModalConclusao(props.showModal);
				dispatch(commonActions.showFadeCarregando(false));
			}
		} else {
			dispatch(commonActions.showFadeCarregando(false));
		}
	}, [props.showModal]);

	const toggle = () => {
		setShowModalConclusao(!showModalConclusao);
		props.onModal(!showModalConclusao);
	};

	return (
		<Modal
			className="modal-autotext modal-editor"
			centered
			isOpen={showModalConclusao}
			toggle={toggle}
		>
			<ModalHeader toggle={!props.close ? toggle : props.close}>
				<IntlMessage id = "dashboards.examDetail.reportConclusionExam"/>
			</ModalHeader>
			<ModalBody>
				<EditorContainer history={history} />
			</ModalBody>
			<ModalFooter>
				<Button
					onClick={!props.cancelar ? toggle : props.cancelar}
					className="button-cancel"
					color="secondary"
				>
					<IntlMessage id = "dashboards.examDetails.cancel"/>
				</Button>
				<Button
					className="button-confirm"
					onClick={() => verificaEditor()}
					color="primary"
				>
					<IntlMessage id = "dashboards.examDetail.reportAndConclusion"/>
				</Button>
			</ModalFooter>
		</Modal>
	);
}



// WEBPACK FOOTER //
// ./src/containers/ModalConclusao/index.jsx